<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="incidentquantumForm">
      <div class="">
        <h3 class="form_name">IncidentQuantum</h3>


        <div class="input">
          <label for="">IncidentQuantum of Impact Name</label>
          <input type="text" class="default_input reference-form" formControlName="IncidentQuantumName" />
        </div>

        <div class="input">
          <label for="">Distributor Factor Name</label>
          <input type="text" class="default_input reference-form" formControlName="DistributorFactorName" />
        </div>

        <div class="input">
          <label for="">Distributor Factor Value</label>
          <input type="number" class="default_input reference-form" formControlName="DistributorFactorValue" />
        </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(incidentquantumForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(incidentquantumForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>


      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for IncidentQuantum" [formControl]="control"
          [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(incidentquantums | filterReference: control.value) as result">
              <app-option (click)="selectIncidentQuantum(option.id)" *ngFor="let option of result"
                [value]="option.IncidentQuantumName">
                {{ option.IncidentQuantumName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">IncidentQuantum Name</span>
        <span class="item">Distributor Factor Name</span>
        <span class="item">Distributor Factor Value</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content">
        <div class="the_body"
          *ngFor="let incidentquantum of incidentquantumFormArray.get('IncidentQuantums')['controls']; index as i"
          (click)="onEdit(i, incidentquantum.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{incidentquantum.value.IncidentQuantumName}}</span>
          <span class="content">{{incidentquantum.value.DistributorFactorName}}</span>
          <span class="content">{{incidentquantum.value.DistributorFactorValue}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteIncidentQuantum(i, incidentquantum.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(incidentquantumFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
